<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (type of deviceTypes | async; track trackBy(type)) {
      <lcs-option [value]="type" id="lcs-option-id-{{ type.deviceTypeId }}">
         {{ type.name }}
      </lcs-option>
      }
   </div>
</ng-template>
